import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { getPostBySlug, BLOG_POSTS, BRAND } from '../data/siteContent';

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);
  if (!post) return <Navigate to="/blog" replace />;

  const related = BLOG_POSTS.filter((p) => p.slug !== post.slug).slice(0, 2);

  return (
    <MarketingLayout seoTitle={`${post.title} | ${BRAND.name}`} seoDescription={post.excerpt}>
      <header className="mk-page-hero">
        <div className="mk-container" style={{ maxWidth: 800 }}>
          <span className="mk-eyebrow">{post.category}</span>
          <h1>{post.title}</h1>
          <p>
            {post.date} · {post.readMins} min read
          </p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container mk-article">
          {post.body.map((para) => (
            <p key={para.slice(0, 32)}>{para}</p>
          ))}
          <div className="mk-article-cta">
            <h3>Ready to prepare with Success Bridge?</h3>
            <div className="mk-inline-actions">
              <Link to="/signup" className="mk-btn mk-btn-primary">
                Enroll Now
              </Link>
              <Link to="/pricing" className="mk-btn mk-btn-secondary">
                View plans
              </Link>
            </div>
          </div>
          {related.length ? (
            <div className="mk-related">
              <h3>Related reading</h3>
              <div className="mk-blog-list-compact">
                {related.map((p) => (
                  <Link key={p.slug} to={`/blog/${p.slug}`} className="mk-blog-row">
                    <span className="material-symbols-outlined">{p.icon}</span>
                    <div>
                      <strong>{p.title}</strong>
                      <small>{p.category}</small>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ) : null}
          <Link to="/blog" className="mk-text-link" style={{ marginTop: 24, display: 'inline-flex' }}>
            <span className="material-symbols-outlined">arrow_back</span> Back to blog
          </Link>
        </div>
      </section>
    </MarketingLayout>
  );
}
